export class ListCustomerPaymentViewModel {
    id: number = 0;
    code: string;
    hubCreatedId: number;
    customerId: number;
    totalShipment: number;
    grandTotal: number;
    adjustPrice: number;
    attachmentId: number;
    shipmentIds: number[] = [];
    listShipmentNumberS:ShipmentCustomerPay[]=[];
    dateFrom: Date;
    paymentAmount: number;
    dateTo: Date;
    listCustomerPaymentTypeId: number = 1;
    note: string;
    locked: boolean;
    paymentMethodId:number = 1;
    phoneNumber:string;
}

export class ShipmentCustomerPay{
    shipmentId:number;
    shipmentNumberS:string;
    priceCNNG:number;
    priceCNNN:number;
    deposits:number;
}